import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "../util/api";

//get video data:
export const getVideoInfo = createAsyncThunk("mediaItemPage/getVideoInfo", async ({id, language}) => {
    const {
        data: {data = {}, message = [{}]},
    } = await api
        .get(`v2/api/videos/${id}`, {
            params: {
                language,
            },
        })
        .catch(err => {
            throw new Error(err.response.data.message[0]?.text);
        });
    return {videoInfo: data, videoInfoError: message?.[0]};
});

//getNetgraph Data:
export const getVideoNetgraphData = createAsyncThunk(
    "mediaItemPage/getVideoNetgraphData",
    async ({id, page, language}) => {
        const {
            data: {data = [], message = [{}]},
        } = await api
            .get(`v2/api/${page}/${id}/netgraph`, {
                params: {
                    language,
                },
            })
            .catch(err => {
                throw new Error(err.response.data.message[0]?.text);
            });

        return {netGraphData: data, netgraphDataError: message[0]};
    }
);

//getNetgraph Config:
export const getVideoNetgraphConfig = createAsyncThunk("mediaItemPage/getVideoNetgraphConfig", async type => {
    const {
        data: {data = [{}]},
    } = await api.get(`/api/component/${type}`).catch(err => {
        throw new Error(err.response.data.message[0]?.text);
    });

    return {
        videoNetgraphConfig: data[0].config,
    };
});

//get insights:
export const getVideoNetgraphInsights = createAsyncThunk(
    "mediaItemPage/getVideoNetgraphInsights",
    async ({id, page}) => {
        const {data} = await api.get(`v2/api/${page}/${id}/netgraph/features`).catch(err => {
            throw new Error(err.response.data.message[0]?.text);
        });

        return {
            videoNetgraphInsights: data?.data || [],
        };
    }
);

//get carousel:
export const getCarousel = createAsyncThunk("mediaItemPage/getCarousel", async () => {
    const {data} = await api.get("/v2/api/videos/recommended").catch(err => {
        throw new Error(err.response.data.message[0]?.text);
    });

    return {carousel: data?.data || []};
});

//getNetgraph Data:
export const getTextFileUrl = createAsyncThunk(
    "mediaItemPage/getTextFileUrl",
    async ({id, language}) => {
        const {
            data: {data = [], message = [{}]},
        } = await api
            .get(`v2/api/videos/${id}/transcript/text`, {
                params: {
                    language,
                },
            })
            .catch(err => {
                throw new Error(err.response.data.message[0]?.text);
            });

        return {textFileUrl: data, textFileUrlError: message[0]};
    }
);

export const getCaptionsFileUrl = createAsyncThunk(
    "mediaItemPage/getCaptionsFileUrl",
    async ({id, language}) => {
        const {
            data: {data = [], message = [{}]},
        } = await api
            .get(`v2/api/videos/${id}/transcript/captions`, {
                params: {
                    language,
                },
            })
            .catch(err => {
                throw new Error(err.response.data.message[0]?.text);
            });

        return {captionsFileUrl: data, captionsFileUrlError: message[0]};
    }
);

const initialState = {
    videoInfo: {data: {}, status: "idle", error: null},
    netGraphData: {data: [], status: "idle", error: null},
    textFileUrl: {data: null, status: "idle", error: null},
    captionsFileUrl: {data: null, status: "idle", error: null},
    videoNetgraphConfig: {data: {}, status: "idle", error: null},
    videoNetgraphInsights: {data: [], status: "idle", error: null},
    isConceptualSearch: false,
    videoTerm: {},
    carousel: {data: [], status: "idle", error: null},
};

const videoPageSlice = createSlice({
    name: "mediaItemPage",
    initialState,
    reducers: {
        clearVideoPage: () => initialState,
        setVideoTerm: (state, action) => {
            state.videoTerm = action.payload;
        },
        setIsConceptualSearch: (state, action) => {
            state.isConceptualSearch = action.payload;
        },
    },
    extraReducers: {
        [getVideoInfo.pending]: state => {
            state.videoInfo.status = "loading";
        },
        [getVideoInfo.fulfilled]: (state, action) => {
            state.videoInfo.status = "succeeded";
            state.videoInfo.data = action.payload.videoInfo;
            state.videoInfo.error = action.payload.videoInfoError;
        },
        [getVideoInfo.rejected]: (state, action) => {
            state.videoInfo.status = "failed";
            state.videoInfo.error = action.error.message;
        },

        [getVideoNetgraphData.pending]: (state, action) => {
            state.netGraphData.status = "loading";
        },
        [getVideoNetgraphData.fulfilled]: (state, action) => {
            state.netGraphData.status = "succeeded";
            state.netGraphData.data = action.payload.netGraphData;

            state.netGraphData.error = action.payload.netgraphDataError;
        },
        [getVideoNetgraphData.rejected]: (state, action) => {
            state.netGraphData.status = "failed";
            state.netGraphData.error = action.error.message;
        },

        [getVideoNetgraphConfig.pending]: (state, action) => {
            state.videoNetgraphConfig.status = "loading";
        },
        [getVideoNetgraphConfig.fulfilled]: (state, action) => {
            state.videoNetgraphConfig.status = "succeeded";
            state.videoNetgraphConfig.data = action.payload.videoNetgraphConfig;
        },
        [getVideoNetgraphConfig.rejected]: (state, action) => {
            state.videoNetgraphConfig.status = "failed";
            state.videoNetgraphConfig.error = action.error.message;
        },

        [getVideoNetgraphInsights.pending]: (state, action) => {
            state.videoNetgraphInsights.status = "loading";
        },
        [getVideoNetgraphInsights.fulfilled]: (state, action) => {
            state.videoNetgraphInsights.status = "succeeded";
            state.videoNetgraphInsights.data = action.payload.videoNetgraphInsights;
        },
        [getVideoNetgraphInsights.rejected]: (state, action) => {
            state.videoNetgraphInsights.status = "failed";
            state.videoNetgraphInsights.error = action.error.message;
        },

        [getCarousel.pending]: (state, action) => {
            state.carousel.status = "loading";
        },
        [getCarousel.fulfilled]: (state, action) => {
            state.carousel.status = "succeeded";
            state.carousel.data = action.payload.carousel;
        },
        [getCarousel.rejected]: (state, action) => {
            state.carousel.status = "failed";
            state.carousel.error = action.error.message;
        },
        [getTextFileUrl.pending]: (state, action) => {
            state.textFileUrl.status = "loading";
        },
        [getTextFileUrl.fulfilled]: (state, action) => {
            state.textFileUrl.status = "succeeded";
            state.textFileUrl.data = action.payload.textFileUrl;

            state.textFileUrl.error = action.payload.netgraphDataError;
        },
        [getTextFileUrl.rejected]: (state, action) => {
            state.textFileUrl.status = "failed";
            state.textFileUrl.error = action.error.message;
        },
        [getCaptionsFileUrl.pending]: (state, action) => {
            state.captionsFileUrl.status = "loading";
        },
        [getCaptionsFileUrl.fulfilled]: (state, action) => {
            state.captionsFileUrl.status = "succeeded";
            state.captionsFileUrl.data = action.payload.captionsFileUrl;

            state.captionsFileUrl.error = action.payload.netgraphDataError;
        },
        [getCaptionsFileUrl.rejected]: (state, action) => {
            state.captionsFileUrl.status = "failed";
            state.captionsFileUrl.error = action.error.message;
        },
    },
});

export const {clearVideoPage, setVideoTerm, setIsConceptualSearch} = videoPageSlice.actions;

export const isNetgraphLoading = ({mediaItemPage}) => {
    return (
        mediaItemPage.netGraphData?.status === "idle" ||
        mediaItemPage.netGraphData?.status === "loading" ||
        mediaItemPage.videoNetgraphConfig?.status === "idle" ||
        mediaItemPage.videoNetgraphConfig?.status === "loading"
    );
};

export const isVideoInfoLoading = ({mediaItemPage}) =>
    mediaItemPage.videoInfo?.status === "idle" || mediaItemPage.videoInfo?.status === "loading";

export const selectTextFileUrl = ({mediaItemPage}) => mediaItemPage.textFileUrl
export const selectCaptionsFileUrl = ({mediaItemPage}) => mediaItemPage.captionsFileUrl


export default videoPageSlice.reducer;
